<template>
  <a-config-provider :locale="locale">
    <div
      id="app"
      :style="{ background: !isBg ? 'linear-gradient(165deg, #e8efe9 0%, #f7f4ef 48%, #eef3ef 100%)' : 'none' }"
    >
      <div
        class="back-style"
        :style="{
          background: !isBg
            ? 'radial-gradient(90% 60% at 8% 0%, rgba(26, 107, 92, 0.14), transparent 55%), radial-gradient(70% 50% at 100% 100%, rgba(196, 92, 38, 0.08), transparent 50%)'
            : 'none'
        }"
      ></div>
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
export default {
  name: 'App',
  data() {
    return {
      locale: zhCN,
      isBg: false
    };
  },
  watch: {
    '$route'(to, from) {
      console.log('路由变化:', to, from);
      this.isBg = to.path.includes('login');
      if (!this.isBg){
        this.checkLogin()
      }
    }
  },
  methods:{
    // 判断用户是否登录,没有登录则跳转登录页面
    checkLogin() {
      if (Object.keys(this.$store.state.user.loginInfo).length === 0) {
        this.$message.warn('请重新登录!')
        this.$router.push('/login')
      }
    }
  },
  mounted() {

  },
  created() {

  }
}
</script>

<style scoped lang="scss">
#app {
  width: 100%;
  height: 100%;
  color: #14201c;

  >.back-style {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    z-index: 0;
    pointer-events: none;
  }
}

</style>
